<ng-container [formGroup]="form">
  <ix-input
    formControlName="email"
    type="email"
    [label]="'Email' | translate"
    [tooltip]="helptext.Mail_email_tooltip | translate"
  ></ix-input>
</ng-container>
